import { fieldTypes } from "@ucl/library";

export const EntityTypes = {
  FinancialApplication: {
    EntityType: "FinancialApplication",
    JointAccountOwner: {
      EntityType: "JointAccountOwner",
    },
    KeyPerson: {
      EntityType: "KeyPerson",
    },
  },
} as const;

export const EntityTypeOptions: fieldTypes.Option<string>[] = [
  {
    value: EntityTypes.FinancialApplication.EntityType,
    label: "Financial Application",
  },
  {
    value: EntityTypes.FinancialApplication.JointAccountOwner.EntityType,
    label: "Joint Account Owner",
  },
  {
    value: EntityTypes.FinancialApplication.KeyPerson.EntityType,
    label: "Key Person",
  },
] as const;
